import React from "react";
import "../styles/disclaimerStyles.css"

const Disclaimer = () => {
  return (
    <>
      <div className="disclaimer-container">
        <div className="disclaimer-content">
          <h2 className="disclaimer-heading">Disclaimer</h2>
          <p>
            <p>
              All content present on this site is the exclusive property of
              TimeWatch. The Product, text, images, graphics, video and catalog
              used on this site belong to TimeWatch. No material from this site
              may be copied, modified, reproduced, republished, uploaded,
              transmitted, posted or distributed in any form without prior
              written permission from TimeWatch. All rights not expressly
              granted herein are reserved. Unauthorized use of the materials
              appearing on this site may violate copyright, trademark and other
              applicable laws, and could result in criminal or civil penalties.
              TimeWatch is a registered trademark of TimeWatch Infocom Pvt Ltd.
              This trademark may not be used in any manner without prior written
              consent from TimeWatch Infocom Pvt Ltd.
              <ul>
                <li>
                  The Site, and all content, materials, information, software,
                  products and services provided on the Site, are provided on an
                  “as is” and “as available” basis. We expressly disclaims all
                  warranties of any kind, as per OEM standard form
                </li>
                <li>
                  TimeWatch shall have no responsibility for any damage, burnt
                  or loss of data.
                </li>
                <li>
                  TimeWatch may change or discontinue any aspect of its website
                  at any time, including, its content or features. TimeWatch
                  reserves the right to change the terms and conditions
                  applicable to use of the Site. Such changes shall be effective
                  immediately upon notice, which shall be placed on the Site.
                </li>
                <li>
                  The information contained in the Site has been obtained from
                  sources believed to be reliable. TimeWatch disclaims all
                  warranties as to the accuracy, completeness or adequacy of
                  such information.
                </li>
              </ul>
              <p>
                Note: We do not provide online sales & support through online
                platform like flipkart, amazon, ebay, etc.
              </p>
            </p>
          </p>
        </div>
      </div>
    </>
  );
};

export default Disclaimer;
